const translations = window?.languageTranslations;

export const facetHeaderTemplate = (html, attribute, currency = '') => {
	if (!translations) return;
	const facetsTitles = JSON.parse(translations);

	// TODO: consider changing span to h2 or h3 for better page navigation
	return html`<span>${facetsTitles[attribute]} ${currency ?? ''}</span>`;
};

export const facetBodyTemplate = (item, html, facetAttributeName) => {
	const { label, count, isRefined } = item;
	const customClassName = 'ais-FacetCheckbox';

	return html`
		<label class="${customClassName}-label">
			<input
				id="${facetAttributeName}_${label}"
				class="${customClassName}-checkbox"
				type="checkbox"
				value="${label}"
				checked="${isRefined}"
			/>
			<span class="${customClassName}-facetName">${label} (${count})</span>
		</label>
	`;
};
